export const NDA_LEVEL = {
    only_in_person: { label: "Only In Person" },
    only_email: { label: "Only Email" },
    only_call_or_screen_sharing: { label: "Only Call or Screen Sharing" },
    strict_no: { label: "Strict No" },
    only_website: { label: "Only Website" },
    publicly_available: { label: "Publicly Available" },
};

export const INDUSTRY = {
    energy: { label: "Energy (Oils & Energy)" },
    materials: { label: "Materials (Raw Materials) "},
    industrials: { label: "Industrials (Industrial Goods)" },
    consumer_discretionary: { label:"Consumer Discretionary (Lifestyle & Leisure)" },
    consumer_staples: { label: "Consumer Staples (Everyday Essentials)" },
    health_care: { label: "Health Care (Health & Medicine)" },
    financials: { label: "Financials (Banking & Finance)" },
    information_technology: { label: "Information Technology (Tech & Software)" },
    communication_services: { label: "Communication Services (Media & Telecom)" },
    utilities: { label: "Utilities (Utilities & Power)" },
    real_estate: { label: "Real Estate (Property & Real Estate)" }
}

